import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';

import {PriceInfo} from '../priceInfo';

const EventTickets = ({showPriceInfo, isSeePrices, ticketCurrencyCode, price}) => {
  if (isSeePrices) {
    return (
      <div className="EventItem__Tickets">
        <div className="EventItem__PriceWrapper EventItem__SeePrice EventItem__PriceWrapper--phone">
          <FormattedMessage id="EventItem.seePrices" defaultMessage="See prices" />
        </div>
        <Button className="EventItem__PriceWrapper EventItem__SeePrice EventItem__PriceWrapper--desktop">
          <FormattedMessage id="EventItem.seePrices" defaultMessage="See prices" />
        </Button>
      </div>
    );
  }

  if (!showPriceInfo) {
    return null;
  }

  return (
    <div className="EventItem__Tickets">
      <div className="EventItem__PriceWrapper EventItem__PriceWrapper--phone">
        <PriceInfo currency={ticketCurrencyCode} price={price} />
      </div>
      <Button variant="secondary" className="EventItem__PriceWrapper EventItem__PriceWrapper--desktop">
        <PriceInfo currency={ticketCurrencyCode} price={price} />
      </Button>
    </div>
  );
};

EventTickets.propTypes = {
  // If true, indicates that the price information should be shown
  showPriceInfo: PropTypes.bool,

  // / If true, indicates that the user can see prices
  isSeePrices: PropTypes.bool,

  // The currency code for the ticket price
  ticketCurrencyCode: PropTypes.string,

  // The price of the ticket
  price: PropTypes.number,
};

export default EventTickets;
